<template>
  <div class="proposal-user-info__wrapper" v-if="field.type === 'string'">
    <r-text type="caption">
      {{ $t(`proposal-user-info:input-${field.value}`) }}
      <r-text
        type="caption"
        style="display: inline"
        v-if="field.value !== 'middle_name' && field.value !== 'position'"
      >
        *
      </r-text>
    </r-text>
    <div class="proposal-user-info__block-row__content">
      <el-input
        :disabled="disabled"
        size="mini"
        :placeholder="$t(`proposal-user-info:input-${field.value}`)"
        class="r-input"
        v-model="proposal[field.value]"
      />
    </div>
  </div>
  <div class="proposal-user-info__wrapper" v-else-if="field.type === 'email'">
    <r-text type="caption">
      {{ $t(`proposal-user-info:input-${field.value}`) }}
      <r-text type="caption" style="display: inline">*</r-text>
    </r-text>
    <div class="proposal-user-info__block-row__content">
      <el-input
        :disabled="disabled"
        type="email"
        size="mini"
        name="email"
        :placeholder="$t(`proposal-user-info:input-${field.value}`)"
        class="r-input"
        v-model="proposal[field.value]"
      />
    </div>
  </div>
  <div class="proposal-user-info__wrapper" v-else-if="field.type === 'date'">
    <r-text type="caption">
      {{ $t(`proposal-user-info:input-${field.value}`) }}
    </r-text>
    <div class="proposal-user-info__block-row__content">
      <el-date-picker
        :disabled="disabled"
        class="r-date-picker"
        v-model="proposal[field.value]"
        type="datetime"
        size="mini"
        name="datetime"
        clearable
        format="dd.MM.yyyy HH:mm"
        :placeholder="$t(`proposal-user-info:input-${field.value}`)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    field: { type: Object, required: true, default: () => null },
    proposal: { type: Object, required: true, default: () => null },
    disabled: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss" scoped>
.el-date-editor.r-date-picker.el-input {
  width: 100%;
}
.proposal-user-info__wrapper {
  .r-text {
    margin-bottom: 4px;
  }
}
</style>

<i18n>
{
  "ru": {
    "proposal-user-info:input-name": "Логин",
    "proposal-user-info:input-email": "Электронная почта",
    "proposal-user-info:input-last_name": "Фамилия",
    "proposal-user-info:input-first_name": "Имя",
    "proposal-user-info:input-middle_name": "Отчество",
    "proposal-user-info:input-company": "Компания",
    "proposal-user-info:input-position": "Должность",
    "proposal-user-info:input-valid_until": "Срок действия аккаунта",
    "proposal-user-info:input-password": "Пароль"
  },
  "en": {
    "proposal-user-info:input-name": "Login",
    "proposal-user-info:input-email": "Email",
    "proposal-user-info:input-last_name": "Last name",
    "proposal-user-info:input-first_name": "First name",
    "proposal-user-info:input-middle_name": "Middle name",
    "proposal-user-info:input-company": "Company",
    "proposal-user-info:input-position": "Position",
    "proposal-user-info:input-valid_until": "Account expiration date",
    "proposal-user-info:input-password": "Password"
  }
}
</i18n>
